import routes from '@routes/config';

export default [{
    path: routes.proformaBillRow.index,
    name: routes.proformaBillRow.index,
    component: () => import(/* webpackChunkName: "ProformaBillRow" */  '@components/ProformaBillRow/Index')
}]
            